export default __webpack_public_path__ + "static/media/mid-b-13-med.df321821.jpg";